// Querys and Mutations
import {
    GET_WITH_PAGINATION,
    ALL_ACTIVE_AND_CONNECTED,
    CREATE,
    UPDATE,
    DELETE,
    UPDATE_STATUS_CONNECTION,
    CONNECT,
    UPDATE_INFO
} from '@/graphql/config/DevicesGraphql'

// models
import { Paginator, ResponseDefault, ResponseCustom } from '@/models'
import { DeviceModel, DeviceForm, DevicesWithPagination, UpdateInfoDevice } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class DeviceService {
    async getWithPagination (perPage = 10, page = 1): Promise<DevicesWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.devicesWithPagination.paginatorInfo
        const data: DeviceModel[] = result.data.devicesWithPagination.data
        const response: DevicesWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    async getAllActivedAndConnected (): Promise<DeviceModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE_AND_CONNECTED
        })
        return result.data.devicesActiveAndConnected
    }

    /**
     * Mutations
     */
     async create (form: DeviceForm): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async update (id: number, form: DeviceForm): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async changeStatusConnection (id: number, status: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: UPDATE_STATUS_CONNECTION,
            variables: {
                id: id,
                status: status
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async updateInfo (id: number, input: UpdateInfoDevice): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: UPDATE_INFO,
            variables: {
                id: id,
                input: input
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async connect (id: number): Promise<ResponseCustom> {
        const result = await apolloClient.mutate({
            mutation: CONNECT,
            variables: {
                id: id
            }
        })

        if (result.data.connectDevice.success) {
            return {
                success: true,
                error: false,
                msg: ''
            }
        }
        return {
            success: false,
            error: true,
            msg: result.data.connectDevice.msgError
        }
    }
}

export default new DeviceService()
